<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Collection By Customer</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="repairs"
              :search="search"
              :mobile-breakpoint="zeroValue"
            >
              <!-- action template -->
              <template v-slot:item.ItemState="{ item }">
                <span v-if="item.ItemState == 0" style="color: green">Pending Repair</span>
                <span v-if="item.ItemState == 1" style="color: blue">Fixed & Okay</span>
                <span v-if="item.ItemState == 2" style="color: red">Beyond Repair</span>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.DeliveryStatus="{ item }">
                <v-btn color="accent" text @click="dealerModal(item)">Return To Customer</v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>

        <v-row>
          <!-- delivery status dialog -->
          <v-dialog v-model="deliveryDialog" max-width="750px">
            <v-card>
              <v-toolbar dense color="primary" dark>
                <v-toolbar-title>Give Back To Customer</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="deliveryDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <v-container fluid class="subtitle-2 text--primary">
                  <v-row class="subtitle-2 text--primary">
                    <v-col cols="12" xs="12" md="6">
                      Job No: {{activeItem.JobNo}}
                      <br />
                      Customer: {{activeItem.CustomerName}}
                      <br />
                      Phone No: {{activeItem.CustomerPhone}}
                    </v-col>

                    <v-col cols="12" xs="12" md="6">
                      <div v-if="activeItem.product">
                        Item:
                        <span style="color: red">{{activeItem.product.Name}}</span>
                      </div>Problem Details:
                      <span style="color: red">{{activeItem.ProblemDetails}}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="12">
                      <v-textarea
                        outlined
                        rows="2"
                        label="Comments"
                        v-model="record.ReleaseComments"
                      ></v-textarea>
                    </v-col>

                    <v-col cols="12" xs="12" md="6">
                      <v-text-field v-model="record.ReleasedBy" outlined dense label="Released By"></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" md="6">
                      <v-text-field
                        v-model="record.CollectedBy"
                        outlined
                        dense
                        label="Collected By"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" xs ="12" sm="12" md="6">
                      <DatePicker @date="setDate" :myDate="date" :title="`Release Date`"></DatePicker>
                    </v-col>

                    <v-col cols="12" xs ="12" sm="12" md="6">
                      <v-btn color="accent" @click="releaseItem" :loading="$store.state.btnLoader">Release Item</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of delivery status modal-->

          <snackbar ref="snackbar"></snackbar>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    activeItem: {},
    statusDialog: false,
    deliveryDialog: false,
    Dealer: null,
    assignDialog: false,
    zeroValue: 0,
    loader: false,
    pageItems: 100,
    record: {},
    date: new Date().toISOString().substr(0, 10),
    repairStatus: [
      { Name: "Fixed & okay", value: 1 },
      { Name: "Beyond Repair", value: 2 },
    ],
    headers: [
      { text: "Job No.", value: "JobNo" },
      { text: "Customer", value: "CustomerName" },
      { text: "Phone No.", value: "CustomerPhone" },
      { text: "Item", value: "product.Name" },
      { text: "Problem Details", value: "ProblemDetails" },
      { text: "Item Status", value: "ItemState" },
      { text: "Released By", value: "ReleasedBy" },
      { text: "Collected By", value: "CollectedBy" },
      { text: "Release Date", value: "ReleaseDate" },
    ],
    dealers: [],
    repairs: [],
    users: [],
  }),
  methods: {
    setDate(date) {
      this.record.ReleaseDate = date;
    },
    dealerModal(data) {
      this.activeItem = data;
      this.deliveryDialog = true;
    },
    releaseItem() {
      if (
        this.record.ReleasedBy == null ||
        this.record.ReleasedBy == undefined
      ) {
        this.$refs.snackbar.show("Please fill released the item", "red");
      } else {
        if (
          this.record.CollectedBy == null ||
          this.record.CollectedBy == undefined
        ) {
          this.$refs.snackbar.show("Please fill who collected the item", "red");
        } else {
          let data = this.record;
          data.id = this.activeItem.id;
          const url = `/repair/release/item`;
          const self = this;
          this.$store.commit("btnLoader", true);
          this.$store
            .dispatch("post", { url, data })
            .then((res) => {
              if (res.ResultCode == 1200) {
                self.$refs.snackbar.show("Released successfully", "green");
                self.loader = false;
                self.deliveryDialog = false;
                this.record = {};
                this.activeItem = {};
                self.$store.commit("btnLoader", false);
                self.getRepairs();
              } else {
                self.$store.commit("btnLoader", false);
                this.$refs.snackbar.show(res.ResultDesc, "red");
              }
            })
            .catch((err) => {
              self.$store.commit("btnLoader", false);
              this.$refs.snackbar.show(err, "red");
            });
        }
      }
    },
    getRepairs() {
      const self = this;
      this.$store
        .dispatch("get", `/repairs/3`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.repairs = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRepairs();
    this.getUsers();
  },
};
</script>